import { Outlet, useLocation, useNavigate } from "react-router";
import RouteWrapper from "components/RouteWrapper";
import { useEffect } from "react";
import { getRole } from "utils/helper.utils";
import { DASHBOARD_URL } from "constants/app";

const UnauthorisedUser = () => {
  const navigate = useNavigate()
  const location = useLocation()
  useEffect(() => {
    (() => {
      const role = getRole();
      if(role) {navigate(DASHBOARD_URL[role]);
        return;
      }

      if(location.pathname === "/"){
        navigate("/login")
      }
    })()
  }, [])

  return (
    <RouteWrapper>
      <div className="sign-in-bg">
        <div className="app-wrapper d-block">
          <div className="main-container">
            <div className="container">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </RouteWrapper>
  );
};

export default UnauthorisedUser;
